/**
 * @module store/emails/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Начало загрузки ордреров
   *
   * @since Version 1.0.2
   */
  [types.GET_EMAILS_ASYNC.PENDING](state) {
    state.isLoading = true;
  },


  /**
   * Mutation: Ошибка при загрузке ордеров
   *
   * @since Version 1.0.2
   */
  [types.GET_EMAILS_ASYNC.FAILURE](state) {
    state.isLoading = false;
  },


  /**
   * Mutation: Успешная загрзка ордеров
   *
   * @since Version 1.0.2
   */
  [types.GET_EMAILS_ASYNC.SUCCESS](state, { data, total }) {
    state.emails = data;
    state.total = total;
    state.isLoading = false;
  },
};
/* eslint-enable no-param-reassign */
